export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/building_complex.186a893.svg";